"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const result_1 = require("../../result");
const api_1 = require("../api");
class Runtime {
    constructor(implementations) {
        this.implementations = implementations;
    }
    execute(code) {
        switch (code.id) {
            case 'id':
                return result_1.ok({
                    type: code.type,
                    value: code.value
                });
            default:
                const implementation = this.implementations.find(x => api_1.operationIdEquals(code.id, x.id));
                if (!implementation) {
                    return result_1.err({ code: 'function-implementation-not-found', id: code.id });
                }
                const parameterResults = code.parameters.map(x => this.execute(x));
                let parameterValues = [];
                for (let result of parameterResults) {
                    if (!result.success) {
                        return result;
                    }
                    parameterValues.push(result.value);
                }
                const result = implementation.func(parameterValues);
                return result_1.ok(result);
        }
    }
}
exports.Runtime = Runtime;
//# sourceMappingURL=runtime.js.map